'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.watchActivityListener = watchActivityListener;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(activityListenerSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchActivityListener);

function activityListenerSaga(action) {
    return _regenerator2.default.wrap(function activityListenerSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.call)(_reduxSaga.delay, 1000 * 60 * 15);

                case 2:
                    // 15 minutes
                    window.location = process.env.LOGOUT_REDIRECT_URL;

                case 3:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function watchActivityListener() {
    return _regenerator2.default.wrap(function watchActivityListener$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _reduxSaga.takeLatest)('*', activityListenerSaga);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/timedLogout.js
// module id = 1665
// module chunks = 0